import BannerSmall from "@/components/landing/common/BannerSmall";
import LatestArticles from "@/components/landing/blogThree/LatestArticles";

export default function BlogTwo() {
  return (
    <main className="overflow-x-hidden">
      <section className="banner-section inner-pages">
        <BannerSmall title="Blogs" />
      </section>

      {/* Latest Articles section */}
      <LatestArticles />
    </main>
  );
}
